import { Set as ImmutableSet } from 'immutable';
const NO_DRILLDOWN = 'NO_DRILLDOWN';
const createNode = (property = NO_DRILLDOWN) => ({
  property,
  counters: [],
  children: {}
});
const addAggregationListToHierarchy = (node, counter, propertyList) => {
  if (!node.counters.includes(counter)) {
    node.counters.push(counter);
  }
  const nextProperty = propertyList.shift();
  if (!nextProperty) {
    return node;
  } else {
    node.children[nextProperty] = addAggregationListToHierarchy(node.children[nextProperty] ? node.children[nextProperty] : createNode(nextProperty), counter, propertyList);
    return node;
  }
};
export const parseSchema = rawSchema => {
  const Hierarchy = rawSchema.rules.reduce((HierarchyRoot, rule) => {
    const counter = rule.counterName;
    HierarchyRoot.counters.push(counter);
    const aggregationsHierarchies = rule.aggregationHierarchies.map(props => props.split('/'));
    return aggregationsHierarchies.reduce((topLevelNode, propertyList) => addAggregationListToHierarchy(topLevelNode, counter, propertyList), HierarchyRoot);
  }, createNode());
  return {
    rawSchema,
    aggregationHierarchy: Hierarchy
  };
};
const getBreakdownPropertiesRecursive = (node, values) => {
  if (node.property !== NO_DRILLDOWN) {
    values = values.add(node.property);
  }
  return Object.keys(node.children).reduce((accumulatedValues, childProperty) => getBreakdownPropertiesRecursive(node.children[childProperty], accumulatedValues), values);
};
export const getBreakdownProperties = schema => {
  return getBreakdownPropertiesRecursive(schema.aggregationHierarchy, ImmutableSet()).toArray();
};
const hydrateNode = (node, breakdownMetaData) => {
  const label = breakdownMetaData[node.property] && breakdownMetaData[node.property].label;
  const children = Object.keys(node.children).reduce((acc, childProperty) => {
    acc[childProperty] = hydrateNode(node.children[childProperty], breakdownMetaData);
    return acc;
  }, {});
  return Object.assign({}, node, {
    children,
    label
  });
};
export const hydrateSchema = (schema, breakdownMetaData) => Object.assign({}, schema, {
  aggregationHierarchy: hydrateNode(schema.aggregationHierarchy, breakdownMetaData)
});